import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { getUserById, updateUser } from "../services/userService";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import FormComponent from "./common/formComponent";
import PageLoading from "./common/pageLoading";

class CustomerInfo extends FormComponent {
  state = {
    data: {
      _id: "",
      fullName: "",
      email: "",
      dob: "",
      phone: "",
      category: "",
      permission: "None",
      address: "",
      notes: undefined,
    },
    errors: {},
    loading: true,
    processing: false,
  };

  schema = {
    _id: Joi.string().required(),
    fullName: Joi.string().required().label("Full Name"),
    email: Joi.string().email().required().label("Email"),
    dob: Joi.date().required().label("Date of Birth"),
    phone: Joi.string().required().label("Phone Number"),
    category: Joi.string().required().label("Category"),
    permission: Joi.string().required().label("Permission"),
    address: Joi.string().required().label("Address"),
    notes: Joi.string().max(50).optional().label("Notes"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const updatedData = this.state.data;
    try {
      await updateUser(updatedData._id, updatedData);
      toast.success("Customer Information Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    const { match } = this.props;
    const customerId = match.params.id;

    try {
      const { data } = await getUserById(customerId);
      this.setState({ data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  render() {
    const { data, errors, loading, processing } = this.state;
    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && (
          <Form className="mt-4" onSubmit={this.handleSubmit}>
            <Form.Group as={Row} controlId="formHorizontalEmail">
              <Form.Label column sm={2}>
                Full Name
              </Form.Label>
              <Col sm={10}>
                <Form.Control
                  name="fullName"
                  onChange={this.handleChange}
                  value={data.fullName}
                  size="sm"
                  type="text"
                />
                {errors.fullName && <span className="text-danger">{errors.fullName}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
              <Form.Label column sm={2}>
                Email
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="email" onChange={this.handleChange} value={data.email} size="sm" type="email" />
                {errors.email && <span className="text-danger">{errors.email}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
              <Form.Label column sm={2}>
                Phone Number
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="phone" onChange={this.handleChange} value={data.phone} size="sm" type="tel" />
                {errors.phone && <span className="text-danger">{errors.phone}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
              <Form.Label column sm={2}>
                Category
              </Form.Label>
              <Col sm={10}>
                <Form.Control plaintext readOnly defaultValue={data.category} />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="address">
              <Form.Label column sm={2}>
                Address
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="address" onChange={this.handleChange} value={data.address} as="textarea" rows="3" />
                {errors.address && <span className="text-danger">{errors.address}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="notes">
              <Form.Label column sm={2}>
                Notes
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="notes" onChange={this.handleChange} value={data.notes} as="textarea" rows="3" />
                {errors.notes && <span className="text-danger">{errors.notes}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={{ span: 10, offset: 2 }}>
                <Button type="submit" disabled={this.validate() || processing}>
                  {processing && (
                    <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                  )}
                  Update
                </Button>
              </Col>
            </Form.Group>
          </Form>
        )}
      </React.Fragment>
    );
  }
}

export default CustomerInfo;
